import { createContext } from "react";

import { SyncFusionDocumentEditorHelper } from "./SyncFusionDocumentEditorHelper.ts";

export const SyncFusionDocumentEditorContext =
  createContext<SyncFusionDocumentEditorHelper>(
    {} as SyncFusionDocumentEditorHelper
  );
